/**
 *
 * Categories
 *
 */
import React, { memo } from 'react';
import { DataTable } from './components/view-list';

interface Props {}

export const Categories = memo((props: Props) => {
  return (
    <div>
      <DataTable />
    </div>
  );
});
